// extracted by mini-css-extract-plugin
export default {"ent":"index_ent_uwADr"};